import React from 'react';
const links = ['Termini di Servizio', 'Privacy Policy', 'Politica di Rimborso', 'Contatti'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-94" data-mp="3ggtzeln15p6t">
      <div className="mx-auto max-w-5xl text-center" data-id="element-95" data-mp="32o4cmezogg8n">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-96" data-mp="32pp7k5pwm171">
          GEOGRAFIA PRONTA™
        </p>
        <nav aria-label="Footer" data-id="element-97" data-mp="3uf0opddwyguv">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-98" data-mp="3ues7xaeo6ree">
            {links.map(link => <li key={link} data-id="element-99" data-mp="3lecbgkwcgkj1">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-100" data-mp="3lf56iolxxllc">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-101" data-mp="29y5hc1uw3mvj">
          © 2026 GEOGRAFIA PRONTA™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}